module.exports = __webpack_public_path__ + "media/bootstrap-icons/file-earmark-diff-fill-3af89ed2.svg";